<template>
    <div class="table-container">
        <!-- Обертка для вертикального скролла -->
        <div class="vertical-scroll-container">
               <!-- Заголовок с логотипами компаний -->
               <div class="companies-header">
                    <div class="region-field">Регионы</div>
                    <div v-for="(company, companyIndex) in value.companies" 
                         :key="'company-header-' + companyIndex" 
                         class="small-field company-logo">
                         <div v-if="company.logo" class="logo-container">
                            <img
                                :alt="company.name.split(' ').slice(0, 4).join(' ')"
                                :src="getUrl(company.logo)"
                                class="company-logo-img"
                                @error="handleImageError"
                            />
                        </div>
                        <div v-else class="placeholder-logo">
                            <span>{{ getInitials(company.name) }}</span>
                        </div>
                        <span class="company-subtext">{{ formatText(company.subtext ? company.subtext : company.name) }}</span>
                    </div>
                </div>
            
                <!-- Тело таблицы -->
                <div class="table-body">
                    <div v-if="value.canEdit">
                        <div class="regions" v-for="(region, regionIndex) in value.regions" 
                             :key="'region-' + regionIndex" v-show="region.show">
                            <div class="region-field">
                                <span>{{ region.val }}</span>
                            </div>
                            <div v-for="(company, companyIndex) in value.companies" 
                                 :key="'cell-' + regionIndex + '-' + companyIndex" 
                                 class="small-field">
                                <v-text-field
                                    :rules="[rules.commission]"
                                    validate-on-blur
                                    v-model.lazy="value.commissions[company.alias][region.id]"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>

                    <div v-if="!value.canEdit">
                        <div class="regions cant-edit-region" 
                             v-for="(region, regionIndex) in value.regions" 
                             :key="'region-ro-' + regionIndex" v-show="region.show">
                            <div class="region-field">
                                <span>{{ region.val }}</span>
                            </div>
                            <div v-for="(company, companyIndex) in value.companies" 
                                 :key="'cell-ro-' + regionIndex + '-' + companyIndex"
                                 class="small-field cant-edit-field">
                                <span>{{ value.commissions[company.alias][region.id] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    props: {
        regionSearch: {
            default: ''
        },
        canEdit: {
            default: false
        },
        regions: {
            default: []
        },
        companies: {
            default: []
        },
        commissions: {
            default: []
        },
    },
    data: () => ({
        searching: false,
        value: {
            canEdit: false,
            regions: [],
            companies: [],
            commissions: [],
        },
        rules: {
            commission: v => ((/^[0-9]+/.test(v) && v <= 100) || v ==='') || 'Ошибка',
        }
    }),
    methods: {
        getUrl(path) {
            return path ? `/${path}` : '';
        },
        formatText(text) {
            if (!text) return '';
            
            // Замена слов "двадцать первый" на "21"
            const replacements = {
                'Двадцать первый': '21',
                // Можно добавить другие замены при необходимости
            };
            
            let formattedText = text;
            for (const [key, value] of Object.entries(replacements)) {
                const regex = new RegExp(key, 'gi');
                formattedText = formattedText.replace(regex, value);
            }
            
            return formattedText;
        },
        // Новый метод: обработка ошибки загрузки изображения
        handleImageError(event) {
            const parent = event.target.parentElement;
            if (parent) {
                // Создаем элемент-заглушку
                const placeholder = document.createElement('div');
                placeholder.className = 'placeholder-logo';
                
                // Получаем инициалы из alt-текста
                const altText = event.target.alt || '';
                const words = altText.split(' ');
                const initials = words.slice(0, 2).map(w => w.charAt(0)).join('');
                
                placeholder.innerHTML = `<span>${initials}</span>`;
                
                // Заменяем изображение на заглушку
                parent.replaceChild(placeholder, event.target);
            }
        },
        // Новый метод: получение инициалов для заглушки
        getInitials(name) {
            if (!name) return '';
            const words = name.split(' ');
            return words.slice(0, 2).map(w => w.charAt(0)).join('');
        }
    },
    created() {
        this.value.canEdit = this.canEdit;
        this.value.regions = this.regions.map(item => {
            let clone = Object.assign({}, item);
            clone.show = true;
            return clone;
        });
        this.value.companies = this.companies;
        this.value.commissions = this.commissions;
    },
    watch: {
        regionSearch() {
            if (this.searching) {
                return;
            }
            this.searching = true;
            this.value.regions.forEach(region => {
                region.show = !this.regionSearch || region.val.toLowerCase().indexOf(this.regionSearch.toLowerCase()) !== -1;
            });
            this.searching = false;
        }
    }
}
</script>

<style scoped>
/* Основные стили без изменений */
.table-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 80vh;
    overflow: hidden;
}

.vertical-scroll-container {
    overflow-y: auto;
    height: 100%;
}

.companies-header {
    display: flex;
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    min-width: fit-content;
}

.region-field {
    position: sticky;
    left: 0;
    width: 240px;
    height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-shrink: 0;
    background: white;
    padding-left: 12px;
    /* box-shadow: 0 0 5px 0 rgba(0,0,0,0.1); */
    z-index: 90;
    font-size: 14px;
}

.companies-header .region-field {
    z-index: 110;
}

.table-body .region-field {
    z-index: 80;
}

.table-body {
    min-width: fit-content;
}

.small-field {
    flex-shrink: 0;
    height: 100px;
    width: 110px;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.company-logo {
    height: 100px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

/* Стили для изображений компаний */
.company-logo-img {
    object-fit: contain;
    max-width: 100%;
    margin-top: 8px;
    height: auto;
    display: block;
}

.logo-container {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Стили для заглушки */
.placeholder-logo {
    width: 60px;
    height: 40px;
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #666;
}

/* Медиа-запросы для адаптации заглушки */
@media (max-width: 992px) {
    .placeholder-logo {
        width: 50px;
        height: 35px;
        font-size: 14px;
    }
}

@media (max-width: 768px) {
    .placeholder-logo {
        width: 40px;
        height: 30px;
        font-size: 12px;
    }
}

@media (max-width: 576px) {
    .placeholder-logo {
        width: 35px;
        height: 25px;
        font-size: 11px;
    }
}

@media (max-width: 480px) {
    .placeholder-logo {
        width: 30px;
        height: 20px;
        font-size: 10px;
    }
}

.company-subtext {
    height: 50px;
    font-size: 12px;
    margin-top: 10px;
}

.cant-edit-field {
    line-height: 100px;
    text-align: center;
}

.regions {
    display: flex;
    min-width: fit-content;
    border-bottom: solid 1px #eeeeee;
}

.cant-edit-region {
    min-height: 100px;
    display: flex;
}

/* Медиа-запросы для адаптации */
@media (max-width: 1200px) {
    .region-field {
        width: 200px;
        height: 90px;
        font-size: 13px;
    }
    .small-field {
        width: 100px;
        height: 90px;
    }
    .company-logo-img {
        height: 40px;
        width: 70px;
    }
    .company-subtext {
        font-size: 11px;
    }
}

@media (max-width: 992px) {
    .region-field {
        width: 180px;
        height: 85px;
        font-size: 12px;
    }
    .small-field {
        width: 90px;
        height: 85px;
    }
    .company-logo-img {
        height: 35px;
        width: 60px;
    }
    .company-subtext {
        font-size: 10px;
    }
}

@media (max-width: 768px) {
    .table-container {
        height: 70vh;
    }
    
    .region-field {
        width: 160px;
        height: 80px;
        font-size: 11px;
        padding-left: 8px;
    }
    .small-field {
        width: 80px;
        height: 80px;
        padding: 0 5px;
    }
    .company-logo-img {
        height: 30px;
        width: 50px;
    }
    .company-subtext {
        font-size: 9px;
        margin-top: 2px;
    }
    .cant-edit-field {
        line-height: 80px;
        font-size: 12px;
    }
    
    /* Уменьшаем размер текста в полях ввода */
    .v-text-field >>> input {
        font-size: 12px !important;
    }
    .v-text-field >>> .v-label {
        font-size: 12px !important;
    }
}

@media (max-width: 576px) {
    .region-field {
        width: 140px;
        height: 70px;
        font-size: 10px;
    }
    .small-field {
        width: 70px;
        height: 70px;
    }
    .company-logo-img {
        height: 25px;
        width: 40px;
    }
    .company-subtext {
        font-size: 8px;
    }
    .cant-edit-field {
        line-height: 70px;
        font-size: 11px;
    }
}

/* Для очень маленьких экранов */
@media (max-width: 480px) {
    .region-field {
        width: 120px;
        height: 65px;
        font-size: 9px;
    }
    .small-field {
        width: 65px;
        height: 65px;
    }
    .company-logo-img {
        height: 20px;
        width: 35px;
    }
    .company-subtext {
        font-size: 7px;
    }
    .cant-edit-field {
        line-height: 65px;
        font-size: 10px;
    }
    
    /* Уменьшаем отступы */
    .companies-header {
        padding-bottom: 5px;
    }
    .region-field {
        padding-left: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/CommissionsTable.vue